import React, { useEffect, useState, useContext } from 'react';
import BackButton from "../components/back_button";
import { Popover } from '@headlessui/react';
import Footer from '../components/footer';
import { AuthContext } from '../contexts/auth';
import ListBox from '../components/list_box';
import ComboboxAutocomplete from '../components/combobox_autocomplete';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Link } from 'wouter';
import { getJustificationsCompanyList } from '../services/api_justifications';



const NewJustificationRequest = () => {
  const prevLocation = '/';
  const backgroudColor = 'bg-pink-700';

  const { loading, token } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [giustificativi, setGiustificativi] = useState([]);
  const [giustificativoSelected, setGiustificativoSelected] = useState('');

  useEffect(() => {
      setIsLoading(true);
      setIsError(false);

      const fetchData = async () => {
          try {
            const giustificativi = await getJustificationsCompanyList(token);
            setGiustificativi(giustificativi);
          } catch (error) {
            console.error('Error fetching justifications:', error);
            setIsError(true);
          } finally {
            setIsLoading(false);
          }
      };

      fetchData();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
  }

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error loading data</div>;

  return <>
    <div className="min-h-full">
      <Popover as="header" className={`${backgroudColor}`}>
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <div className="relative flex flex-wrap items-center justify-center lg:justify-between">
            <div className="w-full -5 lg:border-t lg:border-white lg:border-opacity-20">
              <div className="flex justify-center my-2 py-2">
                <h2 className="text-center text-2xl font-semibold text-white">Richiesta Giustificativi</h2>
              </div>
            </div>
          </div>
        </div>
      </Popover>
      <main className="mt-10 pb-8">
        <div className='container-fluid w-full px-4 pt-2'>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-6 gap-4 mt-2 items-center px-10">
              <div className='col-span-1'>
                <label htmlFor="giustificativo" className="block text-sm font-medium text-gray-700 tracking-wider">
                  Giustificativo
                </label>
              </div>
              <div className='col-span-4'>
                <ComboboxAutocomplete
                  options={giustificativi.map((giustificativo, giustificativoIdx) => ({ id: giustificativo.justification.id, name: giustificativo.justification.description, value: giustificativoIdx + 1 }))}
                  bgActiveColor="bg-gray-100"
                  textActiveColor="text-gray-900"
                  placeholder='Seleziona il giustificativo...'
                  onChange={(selected) => setGiustificativoSelected(selected)}
                  value={giustificativoSelected}
                  positionOptions='relative'
                /> 
              </div>
              <div className='col-span-1'></div>

              <div className='col-span-1'>
                <label htmlFor="giustificativo" className="block text-sm font-medium text-gray-700 tracking-wider">
                  Giorno/i
                </label>
              </div>
              <div className="col-span-2 inline-block">
                <div className="flex items-center justify-between">
                  <span className="mr-2 block text-sm font-medium text-gray-700 tracking-wider w-1/2">Dal</span>
                  <input 
                    type="date" 
                    className="border-gray-200 rounded-md focus:ring-gray-300 focus:border-gray-300 block w-40 shadow-md sm:text-sm" 
                  />
                </div>
              </div>
              <div className="col-span-2 inline-block">
                <div className="flex items-center justify-between">
                  <span className="ml-2 block text-sm font-medium text-gray-700 tracking-wider">Al</span>
                  <input 
                    type="date" 
                    className="border-gray-200 rounded-md focus:ring-gray-300 focus:border-gray-300 block w-40 shadow-md sm:text-sm" 
                  />
                </div>
              </div>
              <div className='col-span-1'></div>

              <div className='col-span-1'>
                <label htmlFor="giustificativo" className="block text-sm font-medium text-gray-700 tracking-wider">
                  Orario
                </label>
              </div>
              <div className="col-span-2 inline-block">
                <div className="flex items-center justify-between">
                  <span className="mr-2 block text-sm font-medium text-gray-700 tracking-wider">Dalle ore</span>
                  <input 
                    type="time" 
                    className="border-gray-200 rounded-md focus:ring-gray-300 focus:border-gray-300 block w-40 shadow-md sm:text-sm" 
                  />
                </div>
              </div>
              <div className="col-span-2 inline-block">
                <div className="flex items-center justify-between">
                  <span className="ml-2 block text-sm font-medium text-gray-700 tracking-wider">Alle ore</span>
                  <input 
                    type="time" 
                    className="border-gray-200 rounded-md focus:ring-gray-300 focus:border-gray-300 block w-40 shadow-md sm:text-sm" 
                  />
                </div>
              </div>
              <div className='col-span-1'></div>

              <div className='col-span-1'>
                <label htmlFor="giustificativo" className="block text-sm font-medium text-gray-700 tracking-wider">
                  Note
                </label>
              </div>
              <div className='col-span-4 w-full'>
                <input 
                  type="text" 
                  className="w-full border-gray-200 rounded-md focus:ring-gray-300 focus:border-gray-300 block shadow-md sm:text-sm" 
                  />
              </div>
              <div className='col-span-1'></div>
            </div>
            
              <div className='col-span-1 flex justify-center pt-5'>
                <button className="bg-pink-700 text-white text-sm px-4 py-2 rounded-md hover:bg-pink-500 focus:outline-none focus:bg-pink-500 w-24 font-semibold">Invia</button>
              </div>
    
          </form>
        </div> 
        
      </main>
      <Footer />
    </div>
  </>;
};

export { NewJustificationRequest }
